import { FC } from 'react'

import { useTranslation } from 'react-i18next'

import clsx from 'clsx'

import { RangeInput } from 'shared/ui/range-input'

import s from './styles.module.scss'

const STEP_MINUTES = 60

const toStep = (value: number) =>
  Math.floor(value / STEP_MINUTES) * STEP_MINUTES

interface Props {
  value?: {
    min?: number
    max?: number
  }
  maxValue?: {
    min?: number
    max?: number
  }
  isDisabled?: boolean
  onChange?: (data: number[]) => void
}

const prepareShowData = (minutes?: number) => {
  if (!minutes)
    return {
      hours: 0,
    }

  return {
    hours: Math.floor(minutes / STEP_MINUTES),
  }
}

export const LineBlock: FC<Props> = ({
  value,
  maxValue,
  isDisabled,
  onChange,
}) => {
  const { t } = useTranslation()

  const minRange = prepareShowData(value?.min)
  const maxRange = prepareShowData(value?.max)

  const bounds = {
    min: toStep(maxValue?.min ?? 0),
    max: toStep(maxValue?.max ?? 0),
  }
  const sliderValue: [number, number] = [
    toStep(value?.min ?? 0),
    toStep(value?.max ?? 0),
  ]

  return (
    <div className={clsx(s.itemBlock, s.transferFilter)}>
      <div className={s.headerTransfer}>
        <p className={clsx(s.left, 'medium-14')}>{t('transfers_duration')}</p>
        <p className={clsx(s.right, 'medium-12')}>
          <span>
            {t('start_with', {
              hours: minRange?.hours || '0',
            })}
          </span>
          {' — '}
          <span>
            {t('end_with', {
              hours: maxRange?.hours || '0',
            })}
          </span>
        </p>
      </div>

      <RangeInput
        onChange={onChange}
        min={bounds.min}
        max={bounds.max}
        value={sliderValue}
        step={STEP_MINUTES}
        disabled={isDisabled}
      />
    </div>
  )
}
